import React, { useState } from "react";
import ButtonCustom from "../../../features/ButtonCustom/ButtonCustom";
import BasketPanel from "./BasketPanel";
import PromotionPanel from "./PromotionPanel";
import { BasketItem } from "../../models/BasketItem";
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight, HiOutlineTrash } from "react-icons/hi";
import { useNavigate } from "react-router";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { BASKET_CALCULATE_PROMOTION, CLEAR_BASKET, EXERCISE_BASKET_CLEAR } from "../../api/apiRoutes";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { isAfternoonTime } from "../../../utils/isAfternoonTime";
import { TicketAccess } from "../../models/TicketAccess";
import { PASS_PAGE, REALIZE_VOUCHER_PAGE, TICKETS_PAGE } from "../../routes";
import useConfigDiscount from "../../../utils/hooks/useConfigDiscount";
import { PASS_SALE, REALIZE_VOUCHER } from "../../models/TypeSale";

interface IProps {
  basket: BasketItem[];
  onRemoveBasket: (value: number) => void;
  updateBasket: (value: BasketItem[]) => void;
  onNextToForm: () => void;
  totalListPrice: number;
  isSaleWithExercise: boolean;
  typeSale: string;
}

const SummaryPanel: React.FC<IProps> = ({
  basket,
  onRemoveBasket,
  updateBasket,
  onNextToForm,
  totalListPrice,
  isSaleWithExercise,
  typeSale
}: IProps) => {
  const navigate = useNavigate();
  const { get } = useApiRequest();
  const isDesktop = useDesktopSize();
  const total = basket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);
  const showTotal = basket.some((item: BasketItem) => item.showPrice);
  const { post } = useApiRequest();
  const isPromotionSummary = totalListPrice - total;
  const isPromotionText = basket.some((item: BasketItem) =>
    item.ticketAccess.some((exercise: TicketAccess) => isAfternoonTime("14:00", exercise.startDate))
  );
  const textButtonReturn =
    basket.length > 0 ? (isSaleWithExercise ? "Wróć do kalendarza" : "Wróć do sklepu") : "Wróć do sklepu";
  const { DISCOUNT_TEXT } = useConfigDiscount();
  const [promoCode, setPromoCode] = useState("");

  const clearBasket = async () => {
    const { isError } = await post(CLEAR_BASKET);
    if (!isError) {
      updateBasket([]);
    }
  };

  const returnToShop = async () => {
    if (basket.length > 0) {
      const { isError } = await post(EXERCISE_BASKET_CLEAR);
      if (!isError) {
        clearPromotion();
      }
    } else {
      if (typeSale === PASS_SALE) {
        navigate(`${PASS_PAGE}`);
      } else if (typeSale === REALIZE_VOUCHER) {
        navigate(`${REALIZE_VOUCHER_PAGE}?isSaleWithExercise=true`);
      } else {
        navigate(`${TICKETS_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
      }
    }
  };

  const clearPromotion = async () => {
    const { isError } = await get(BASKET_CALCULATE_PROMOTION("", true));
    if (!isError) {
      navigate(-1);
    }
  };

  const promotionText = (): string => {
    if (promoCode === "JERONIMO") {
      return "15% taniej";
    }
    if (promoCode === "JUMP20" || promoCode === "BULWARY24") {
      return "20% taniej";
    }
    return "";
  };

  return (
    <div className={"summary-panel"}>
      <div className={"summary-header"}>
        <p>Podsumowanie</p>
        {isDesktop ? (
          basket.length > 0 && (
            <ButtonCustom
              title={typeSale === REALIZE_VOUCHER ? "Wyczyść dane" : "Wyczyść koszyk"}
              className={`button-clear-basket`}
              Icon={HiOutlineTrash}
              iconPosition={"left"}
              onClick={() => clearBasket()}
            />
          )
        ) : basket.length > 0 ? (
          <p>Poniżej znajdują się Twoje bilety. Prosimy o sprawdzenie poprawności zamówienia.</p>
        ) : (
          <p>Koszyk jest pusty, wróc do sklepu</p>
        )}
      </div>
      <BasketPanel
        basket={basket}
        onRemoveBasket={onRemoveBasket}
        title={typeSale === REALIZE_VOUCHER ? "Zrealizuj voucher" : "Twój koszyk"}
      />
      {showTotal && (
        <div className={"summary-footer"}>
          <PromotionPanel updateBasket={updateBasket} setPromoCode={setPromoCode} />
          <div className={"summary-total-panel"}>
            {basket.length > 0 && isPromotionSummary > 0 && (
              <>
                {(promotionText() !== "" || isPromotionText) && (
                  <p className={"summary-promotion"}>{`${isPromotionText ? DISCOUNT_TEXT : promotionText()}`}</p>
                )}
                <p className={"summary-total-list-price"}>{totalListPrice.toFixed(2)} zł</p>
              </>
            )}
            <p className={"summary-total"}>
              Łączna cena: <span>{total.toFixed(2)} zł</span>
            </p>
          </div>
        </div>
      )}
      {isDesktop ? (
        <ButtonCustom
          title={textButtonReturn}
          className={`button-default`}
          Icon={HiOutlineArrowNarrowLeft}
          iconPosition={"left"}
          onClick={() => returnToShop()}
        />
      ) : (
        <div className={"summary-next-mobile"}>
          <ButtonCustom
            title={""}
            className={"button-default"}
            Icon={HiOutlineArrowNarrowLeft}
            iconPosition={"center"}
            onClick={() => returnToShop()}
          />
          <ButtonCustom
            title={"Zgadza się, wypełnij formularz"}
            className={"button-error-color"}
            Icon={HiOutlineArrowNarrowRight}
            iconPosition={"right"}
            onClick={() => onNextToForm()}
          />
        </div>
      )}
    </div>
  );
};

export default SummaryPanel;
